import React, { useState, useEffect } from 'react'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { Helmet } from 'react-helmet-async'
import contact1 from '../Image/contact1.avif'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { LuMailQuestion } from 'react-icons/lu'
import ffffff from '../Image/ffffff.avif'
import Contact_FAQ from '../Component/Contact_FAQ'
function Contact_page() {
  const canonicalUrl = 'https://www.internselite.net/Contact-Us'
  useEffect(() => {
    document.title = 'Contact | InternsElite'
  }, [])
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    text: '',
  })

  const [nameError, setNameError] = useState(' ')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [textError, setTextError] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`)
      } else {
        setNameError('')
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError('Invalid email format')
      } else {
        setEmailError('')
      }
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError('Length Should be 10 Digit')
      } else {
        setPhoneError('')
      }
    }
    if (name === 'text') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setTextError(`Invalid Text format.`)
      } else {
        setTextError('')
      }
    }

    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    $.ajax({
      url: 'https://forms.internselite.net/contactform',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        text: $('[name="text"]').val(),
      },
      success: function (response) {
        Swal.fire({
          title: 'Form Submitted!',
          text:
            "What's next? Our team will review your submission and get back to you with in 24 hours.",
          icon: 'success',
        })
        $('[name="text"]').val('')
        $('[name="fullName"]').val('')
        $('[name="mobileNo"]').val('')
        $('[name="email"]').val('')
      },
      error: function (error) {
        console.error('Error:', error)
      },
    })
  }
  return (
    <div>
      <Helmet>
        <title>
          Contact Us | InternsElite: Get in Touch for Inquiries and Support
        </title>
        <meta
          name="description"
          content="Have questions or need support? Contact InternsElite for any inquiries related to our online internships, professional courses, and services. Our dedicated team is here to assist you. Reach out via email, phone, or our contact form, and well respond promptly."
        />
        <meta
          name="keywords"
          content="contact InternsElite, support, customer service, inquiries, contact information, help desk"
        />
        <meta
          property="og:title"
          content="Contact Us | InternsElite: Get in Touch for Inquiries and Support"
        />
        <meta
          property="og:description"
          content="Discover InternsElite, your gateway to professional growth with top-notch online internships and professional courses. We offer comprehensive training programs in Machine Learning, AI, Web Development, and more, with certification and placement support. Learn from industry experts and gain practical skills to excel in your career."
        />
        <meta property="og:url" content="https://internselite.net/Contact-Us" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Contact Us | InternsElite: Get in Touch for Inquiries and Support"
        />
        <meta
          name="twitter:description"
          content="Have questions or need support? Contact InternsElite for any inquiries related to our online internships, professional courses, and services. Our dedicated team is here to assist you. Reach out via email, phone, or our contact form, and we'll respond promptly."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* -----------------------Mobile View------------------------ */}
      <div>
        <div className="Contact_us_background_image d-sm-block d-md-none mt-5">
          <div className="container-fluid Contact_background_color pt-4">
            <div className="text-center mobile_Contact_Main_text py-5">
              <h1 className="display-2 text-white pt-4">Contact Us</h1>
              <h3 className="text-white fs-5 pt-1">
                Empower your learning journey by reaching out.
              </h3>
            </div>
          </div>
        </div>
        <div className="container d-sm-block d-md-none">
          <div className="Mobile_BDA_background_element d-sm-block d-md-none pb-5 pt-4">
            <div className="col-md-12">
              <div className="mobile_contact_text">
                <h1 className="display-6 text-center">Connect To Excel</h1>
                <h3 className="pt-1 text-center">
                  For a seamless Education Journey.
                </h3>
                <p className="pt-1 text-center pb-2">
                  Unlock the future of education! Reach out for inquiries,
                  enrollment details, and personalized counselling. Let's shape
                  your learning journey together with advanced technology and
                  support.
                </p>
                <div>
                  <img
                    className="contact_img"
                    src={contact1}
                    alt="Contact Image"
                    title="Contact Image"
                  ></img>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="pt-3 pb-4 px-3 shadow-lg border rounded">
                <div className="text-center border-bottom pb-2">
                  <span className="contact_form_main">Contact Us...</span>
                </div>
                <div className="">
                  <form onSubmit={handleSubmit}>
                    <div class="mt-4">
                      <label for="fullName" class="pb-2 px-2 contact_form">
                        <SlUser size="20px" color="#565add" />{' '}Full Name
                      </label>
                      <input
                        className="py-2 form-control"
                        type="text"
                        id="fullName"
                        name="fullName"
                        placeholder="Your answer"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required
                      />
                      {nameError && (
                        <div className="error text-danger">{nameError}</div>
                      )}
                    </div>
                    <div class="mt-3">
                      <label for="email" class="pb-2 px-2 contact_form">
                        <MdOutlineMailOutline size="20px" color="#565add" />{' '}
                        Email Address
                      </label>
                      <input
                        className="py-2 form-control"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Your answer"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                      {emailError && (
                        <div className="error text-danger">{emailError}</div>
                      )}
                    </div>
                    <div class="mt-3">
                      <label for="mobileNo" class="pb-2 px-2 contact_form">
                        <HiOutlinePhone size="20px" color="#565add" /> Phone
                        Number
                      </label>
                      <input
                        className="py-2 form-control"
                        type="tel"
                        id="mobileNo"
                        name="mobileNo"
                        placeholder="Your answer"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        required
                      />
                      {phoneError && (
                        <div className="error text-danger">{phoneError}</div>
                      )}
                    </div>
                    <div class="my-3">
                      <label for="text" class="pb-2 px-2 contact_form ">
                        <LuMailQuestion size="20px" color="#565add" /> Query
                      </label>
                      <textarea
                        rows="3"
                        className="py-2 form-control"
                        type="text"
                        id="text"
                        name="text"
                        placeholder="Your answer"
                        value={formData.text}
                        onChange={handleInputChange}
                        required
                      />
                      {textError && (
                        <div className="error text-danger">{textError}</div>
                      )}
                    </div>
                    <div className="row mt-2 pt-2">
                      <div className="d-flex justify-content-center">
                        <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Contact_button">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------------------Desktop View------------------------- */}
      <div>
        <div className="Contact_us_background_image d-none d-md-block mt-5">
          <div className="container-fluid Contact_background_color py-5">
            <div className="text-center pt-5 mt-5 Contact_Main_text">
              <h1 className="display-3 text-white pt-5">Contact Us</h1>
              <h3 className="text-white display-6 pt-3 pb-5 mb-5">
                Empower your learning journey by reaching out.
              </h3>
            </div>
          </div>
        </div>
        <div className="container d-none d-md-block pb-4">
          <div className="BDA_background_element d-none d-md-block  mt-4">
            <div className="container py-4">
              <div className="row">
                <div className="col-md-7 px-2 pt-3">
                  <div className="contact_text">
                    <h1 className="display-5">Connect To Excel</h1>
                    <h2 className="py-2">For a seamless Education Journey.</h2>
                    <p className="">
                      Unlock the future of education! Reach out for inquiries,
                      enrollment details, and personalized counselling. Let's
                      shape your learning journey together with advanced
                      technology and support.
                    </p>
                    <div>
                      <img
                        className="contact_img pt-5"
                        src={contact1}
                        alt="Contact Image"
                        title="Contact Image"
                      ></img>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 shadow-lg border rounded px-5 pb-4">
                  <div className="mt-4">
                    <span className="contact_form_main">Contact Us...</span>
                    <div className="">
                      <form onSubmit={handleSubmit}>
                        <div class="mt-4">
                          <label for="fullName" class="pb-2 px-2 contact_form">
                            <SlUser size="20px" color="#565add" /> Full Name
                          </label>
                          <input
                            className="py-2 form-control  shadow-sm"
                            type="text"
                            id="fullName"
                            name="fullName"
                            placeholder="Your answer"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            required
                          />
                          {nameError && (
                            <div className="error text-danger">{nameError}</div>
                          )}
                        </div>
                        <div class="mt-3">
                          <label for="email" class="pb-2 px-2 contact_form">
                            <MdOutlineMailOutline size="20px" color="#565add" />{' '}
                            Email Address
                          </label>
                          <input
                            className="py-2 form-control"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Your answer"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                          {emailError && (
                            <div className="error text-danger">
                              {emailError}
                            </div>
                          )}
                        </div>
                        <div class="mt-3">
                          <label for="mobileNo" class="pb-2 px-2 contact_form">
                            <HiOutlinePhone size="20px" color="#565add" />{' '}Phone
                            Number
                          </label>
                          <input
                            className="py-2 form-control"
                            type="tel"
                            id="mobileNo"
                            name="mobileNo"
                            placeholder="Your answer"
                            value={formData.mobileNo}
                            onChange={handleInputChange}
                            required
                          />
                          {phoneError && (
                            <div className="error text-danger">
                              {phoneError}
                            </div>
                          )}
                        </div>
                        <div class="my-3">
                          <label for="text" class="pb-2 px-2 contact_form ">
                            <LuMailQuestion size="20px" color="#565add" /> Query
                          </label>
                          <textarea
                            rows="3"
                            className="py-2 form-control"
                            type="text"
                            id="text"
                            name="text"
                            placeholder="Your answer"
                            value={formData.text}
                            onChange={handleInputChange}
                            required
                          />
                          {textError && (
                            <div className="error text-danger">{textError}</div>
                          )}
                        </div>
                        <div className="row pt-2">
                          <div className="d-flex justify-content-center">
                            <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Contact_button">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FAQ/>
      </div>
    </div>
  )
}

function FAQ(){
  return(
    <div>
      {/* ----------------------Mobile View--------------------     */}
      <div className="mb-5 d-sm-block d-md-none">
        <div className="container">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h1 className="display-6">Frequently Asked Questions</h1>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="FAQ_img">
                <img src={ffffff}></img>
              </div>
            </div>
            <div className="col-md-12">
              <Contact_FAQ/>
            </div>
          </div>
        </div>
      </div>

      {/* -----------------Desktop View---------------- */}
      <div className="d-none d-md-block">
        <div className="container pt-5">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h1 className="display-6">Frequently Asked Questions</h1>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img src={ffffff}></img>
              </div>
            </div>
            <div className="col-md-7">
                <div className="pt-5">
                  <div className="py-5">
                  <Contact_FAQ/>
                  </div>
                </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact_page
